import styled, { css } from 'foundations-theming/utils';

// Copied from: https://git.hubteam.com/HubSpot/customer-data-table/blob/99db417298e9a8ab19b41c7916a6e38a62ed1beb/framework-data-table/static/js/table/components/StyledTableComponents.tsx
const STYLED_TABLE_COMPONENTS_FROZEN_CELL_Z_INDEX = 2;
const normalOutline = css(["box-shadow:inset 0 0 0 ", " ", ";"], ({
  theme
}) => theme.space['25'], ({
  theme
}) => theme.color['border-core-hover']);
const activeHighlight = css(["box-shadow:inset 0 0 0 ", " ", ";"], ({
  theme
}) => theme.space['25'], ({
  theme
}) => theme.color['fill-info-default']);
const errorHighlight = css(["box-shadow:inset 0 0 0 ", " ", ";"], ({
  theme
}) => theme.space['25'], ({
  theme
}) => theme.color['fill-alert-default']);
export const EditCellFloatyWrapper = styled.div.withConfig({
  displayName: "StyledInlineEditCellComponents__EditCellFloatyWrapper"
})(["position:relative;display:flex;min-height:100%;max-width:100%;flex-direction:column;align-items:flex-start;background:", ";box-shadow:0 0 ", " ", ";"], ({
  theme
}) => theme.color['fill-surface-raised'], ({
  theme
}) => theme.space['200'], ({
  theme
}) => theme.color['border-core-hover']);
const editCellPadding = css(["padding-inline:", ";padding-block:", ";"], ({
  theme
}) => theme.space['600'], ({
  theme
}) => theme.space['100']);

// When a cell is in an error state, it contains validation text that is intentionally
// hidden through overflow. The EditCellFloatyWrapper becomes taller than the cell's
// visible area, but we only want to show the input portion. Since the overflow is
// hidden, only the top border of the container remains visible. To maintain visual
// consistency, we need to reduce the min-height by the bottom border width
// (borderWidth['100']).
const heightOfTdWithError = css(["min-height:calc( ", " - ", " );"], ({
  theme
}) => theme.space['1000'], ({
  theme
}) => theme.borderWidth['100']);
const heightOfTd = css(["min-height:calc( ", " - ", " );"], ({
  theme
}) => theme.space['1000'], ({
  theme
}) => theme.borderWidth['100']);
export const EditCellPropertyInputWrapper = styled.div.withConfig({
  displayName: "StyledInlineEditCellComponents__EditCellPropertyInputWrapper"
})(["", " ", " flex-grow:1;width:100%;background:", ";", " display:flex;align-items:center;overflow:hidden;z-index:1;"], editCellPadding, props => props['aria-invalid'] ? heightOfTdWithError : heightOfTd, ({
  theme
}) => theme.color['fill-surface-raised'], props => props['aria-invalid'] ? errorHighlight : normalOutline);
export const EditCellContainer = styled.div.withConfig({
  displayName: "StyledInlineEditCellComponents__EditCellContainer"
})(["flex-grow:1;"]);
export const EditCellErrorText = styled.small.withConfig({
  displayName: "StyledInlineEditCellComponents__EditCellErrorText"
})(["", " color:", ";"], editCellPadding, ({
  theme
}) => theme.color['fill-alert-default']);
const editCellStyle = css(["display:block;&&&{z-index:", ";}padding:", " !important;", " textarea,input{height:auto;min-height:auto;font-size:", ";padding:", ";border:", ";}"], STYLED_TABLE_COMPONENTS_FROZEN_CELL_Z_INDEX + 1, ({
  theme
}) => theme.space['0'], activeHighlight, ({
  theme
}) => theme.typography['body-100'].fontSize, ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.borderWidth['0']);
export const EditCell = styled.td.withConfig({
  displayName: "StyledInlineEditCellComponents__EditCell"
})(["", ""], editCellStyle);
export const EditCellSpan = styled.span.withConfig({
  displayName: "StyledInlineEditCellComponents__EditCellSpan"
})(["", ""], editCellStyle);